<div class="delegation-quick-access-dialog-toolbar space-between items-center">
    <div class="delegation-quick-access-dialog-toolbar-title">
        Delegations assigned to me <span *ngIf="activeDelegations.length">({{activeDelegations.length}})</span>
    </div>
    <button class="nova__button--icon" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-progress-bar mode="indeterminate" *ngIf="isLoading$ | async"></mat-progress-bar>
<div mat-dialog-content class="nova__dialog__content">
    <div class="delegation-cards-wrapper flex-col" *ngIf="activeDelegations.length > 0 else emptyDelegationCard">
        <div *ngFor="let active of activeDelegations">
            <nova-delegation-card [delegation]="active" [aspNetUserId]="aspNetUserId" [condensedView]="true"></nova-delegation-card>
        </div> 
    </div>
    <ng-template #emptyDelegationCard>
        <nova-delegation-empty-card></nova-delegation-empty-card>
    </ng-template>
</div>
